



















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';

@Component({})
export default class BucpButton extends Vue {
  @Prop({ type: String, default: '' })
  public label!: string;

  @Prop({ required: false, type: String, default: 'button' })
  public type!: string;

  @Prop({ default: 'normal' })
  public sizing!: 'normal' | 'small' | 'full-width';

  @Prop({ default: 'primary' })
  public variant!: 'primary' | 'outline' | 'outline-dark' | 'transparent' | 'transparent-dark';

  @Prop({ required: false })
  public to!: Route | string;

  public get tag() {
    return this.to ? (typeof this.to === 'string' ? 'a' : 'router-link') : 'button';
  }
  
  public get hasPrefix(): boolean {
    return !!this.$slots.prefix;
  }
}
